import { schema } from 'normalizr';
import pollOption from './pollOption';

const pollSchema = new schema.Entity('polls', {
  options: [pollOption],
});

export default pollSchema;
